module.exports = __webpack_public_path__ + "static/img/espro.2d10e77b.png";